<template>
  <div class="home-content">
    <div class="first-pard">
      <div @click="util.goblack()"><img src="@/assets/images/base/icon_righ_g.png" /></div>
      <div>{{ name }}/USDT</div>
      <div></div>
    </div>
    <div class="second-pard">
      <!-- <ul class="head-one">
            <li>{{name}}/USDT</li>
            <li></li>
          </ul> -->
      <ul class="head-two">
        <li class="price">
          <div>Latest Price</div>
          <div :class="oneInfo.rate >= 0 ? 'green' : 'red'">{{ oneInfo.now_price }}</div>
          <div>24H Rise Fall</div>
          <div :class="oneInfo.rate >= 0 ? 'green' : 'red'">
            {{ oneInfo.price_change > 0 ? "+" + oneInfo.price_change : oneInfo.price_change }}&nbsp;{{ oneInfo.rate == 0? '' : (oneInfo.rate > 0 ? '+' : '') }}{{ oneInfo.rate }}%
          </div>
        </li>
        <li class="time-name">
          <div>24H Highest Price</div>
          <div>24H Lowest Price</div>
          <div>24H Volume(USDT)</div>
          <div>24H Volume({{ name }})</div>
          <div>24H Transactions</div>
        </li>
        <li class="time-num">
          <div>{{ oneInfo.H }}</div>
          <div>{{ oneInfo.L }}</div>
          <div>{{ oneInfo.amount }}</div>
          <div>{{ oneInfo.vol }}</div>
          <div>{{ oneInfo.count }}</div>
        </li>
      </ul>
    </div>
    <div class="third-pard">
      <div class="tradingview-widget-container">
        <div id="tradingview_27984"></div>
        <div class="tradingview-widget-copyright">
          <!-- <a href="https://cn.tradingview.com/" rel="noopener nofollow" target="_blank">
                <span class="blue-text">在TradingView上跟踪所有市场</span> 
              </a>-->
        </div>
      </div>
    </div>
    <!-- <div class="four-pard-head">
          <ul>
            <li>Currency</li>
            <li>Direction</li>
            <li>Profit</li>
            <li>Opening Date Time</li>
          </ul>
        </div>
        <div class="four-pard-text">
          <ul v-for="(item,index) in orderList" v-bind:key="index">
            <li>{{item.currency}}/USDT</li>
            <li>
              <span style="color:#628808;" v-if="item.buy_up_down==1">Buy Up</span>
              <span style="color:#f6543e;" v-else>Buy Down</span>/{{item.during_second}}s
            </li>
            <li>
              <span v-if="item.money_win_loss>0" style="color:#628808;">{{item.money_win_loss}}</span>
              <span v-else style="color:red">{{item.money_win_loss}}</span>
            </li>
            <li>{{util.formatTime(item.open_time)}}</li>
          </ul>
        </div> -->
    <div class="five-pard">
      <button class="btn-up" @click="showBuy(1)">Buy Up</button>
      <button class="btn-down" @click="showBuy(2)">Buy Down</button>
    </div>
    <van-popup v-model="showBuyPage" position="bottom" closeable close-icon="close">
      <div class="six-pard">
        <div class="xzje">Real available balance: {{ userInfo.money }}</div>
        <div class="xzje">Select order period</div>
        <ul class="btn-during">
          <li v-for="(item, index) in odds" v-bind:key="index">
            <button @click="setDuring(item.during)" :class="buyOrder.during == item.during ? 'on' : ''">
              <span>{{ item.during }}s</span>
              <span>{{ (item.odd - 1).toFixed(2) * 100 + '%' }}</span>
            </button>
          </li>
        </ul>
        <!-- <div class="xzje">Select a fast amount</div> -->
        <!-- <ul class="btn-money">
                <li><button @click="setMoney(100)" :class="buyOrder.money==100?'on':''">100</button></li>
                <li><button @click="setMoney(500)" :class="buyOrder.money==500?'on':''">500</button></li>
                <li><button @click="setMoney(1000)" :class="buyOrder.money==1000?'on':''">1000</button></li>
                <li><button @click="setMoney(5000)" :class="buyOrder.money==5000?'on':''">5000</button></li>
                <li><button @click="setMoney(10000)" :class="buyOrder.money==10000?'on':''">10000</button></li>
                <li><button @click="setMoney(50000)" :class="buyOrder.money==50000?'on':''">50000</button></li>
              </ul> -->
        <div class="xzje">Enter order amount</div>
        <input type="number" class="money" v-model="buyOrder.money" />
        <ul class="order-head" style="grid-template-columns: 33% 33% 33%">
          <li>Currency</li>
          <!-- <li>Direction</li> -->
          <li>Price</li>
          <li>Amount</li>
        </ul>
        <ul class="order-text" style="grid-template-columns: 33% 33% 33%">
          <li>{{ name }}</li>
          <!-- <li style="font-weight:bold;">
                  <span style="color:#628808;" v-if="buyType==1">Buy Up</span>
                  <span style="color:#f6543e;" v-else>Buy Down</span>
                </li> -->
          <li>{{ oneInfo.now_price }}</li>
          <li>{{ buyOrder.money }}</li>
        </ul>
        <div class="errorInfo">{{ errorInfo }}</div>
        <button class="btn-submit" v-show="!showloding" @click="submitbtn" :disabled="isDisable">Submit Order</button>
        <button class="btn-submit" v-show="showloding" :disabled="isDisable">Submit Order</button>
      </div>
    </van-popup>
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
/*global mui*/
import Vue from "vue";
import { Loading } from "vant";
import { Popup } from 'vant';
Vue.use(Loading);
Vue.use(Popup);
export default {
  data() {
    return {
      userInfo: this.util.user,
      oneInfo: {},
      name: "",
      name_2: '',
      showloding: false,
      orderList: [],
      buyType: 0,
      showBuyPage: false,
      errorInfo: "",
      odds: [],
      buyOrder: { during: 30, money: '' },
      timer: null,
      isDisable: false,
    };
  },
  methods: {
    submitbtn() {
      let re = /[^\d]/g;
      if (!this.buyOrder.during) {
        this.errorInfo = "Please select a period";
      } else if (!this.buyOrder.money) {
        this.errorInfo = "Amount cannot be blank";
      } else if (re.test(this.buyOrder.money)) {
        this.buyOrder.money = "";
        this.errorInfo = "Amount can only be a whole number";
      } else if (this.buyOrder.money < 1000) {
        this.buyOrder.money = "";
        this.errorInfo = "Amount cannot be less than 1000";
      } else if (this.buyOrder.money - this.userInfo.money>0) {
        this.errorInfo = "Insufficient balance";
      } else if (!this.showloding) {
        this.errorInfo = "The order is being submitted..";
        this.saveOrder();
      }
    },
    saveOrder() {
      this.isDisable=true;
      let params = {
        betPrice: this.buyOrder.money,
        buyUpDown: this.buyType,
        currencyName: this.name.toLowerCase(),
        duringSecond: this.buyOrder.during,
      };
      this.util.setDnValueUser(params);
      this.axios.post(this.api.api_betOrder, this.util.encodeSearchParams(params)).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          this.buyOrder.money = '';
          this.errorInfo = "";
          mui.toast("The order was placed successfully");
          this.showBuyPage = false;
          this.util.refreshUserInfo((res) => this.userInfo = res);
          this.util.topage('order')
        } else {
          this.errorInfo = res.data.message;
        }
      }).catch(() => {
          this.showloding = false;
          this.errorInfo = "Failed to place the order";
      });
      setTimeout(()=>{
        this.isDisable = false;
      },1500);
    },
    showBuy(buyType) {
      this.errorInfo = "";
      this.showBuyPage = true;
      this.buyType = buyType;
      this.findConfig();
    },
    setDuring(during) {
      this.buyOrder.during = during;
    },
    setMoney(money) {
      this.buyOrder.money = money;
    },
    getOneGains() {
      let set_data = {
        currencyName: this.name_2.toLowerCase(),
        userName: this.util.user.login_name,
        userToken: this.util.user.token
      }
      this.axios.get(this.api.api_findOneNowPriceGains, {
        params: {
          ...set_data,
          dn_value: this.util.get_dn_value(set_data)
        }
      }).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          let newData = [res.data.data].map(item => {
            return {
              //name:item.name.toUpperCase(),
              now_price: item.now,
              //yes_price:item.yes,
              H: item.H,
              L: item.L,
              amount: item.amount,
              vol: item.vol,
              count: item.count,
              price_change: item.price_change,
              //add_time:this.util.formatTime(item.add_time),
              //coin_img:require('@/assets/images/coin/'+item.name.toUpperCase()+'.png'),
              rate: parseFloat(item.rate).toFixed(2),
            }
          })
          this.oneInfo = newData[0];
          let currentPath = this.$route.path;
          if (currentPath == '/kline') {
            this.timer = setTimeout(() => {
              if (this.util.isLogin()) { this.getOneGains(); }
            }, this.util.refreshTime);
          } else {
            window.clearTimeout(this.timer)
          }
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
    getOrder() {
      let params = {
        status: 2,
        startTime: 0,
        endTime: 0,
        winStatus: 1,
      }
      this.util.setDnValueToken(params);
      params.userId = this.util.user.id;
      params.pageNo = 1;
      params.pageSize = 25;
      this.axios.get(this.api.api_getOrder, { params: params }).then(res => {
        this.showloding = false;
        if (res.data.code == 0) {
          this.orderList = res.data.data;
        } else {
          this.util.checkToken(res.data.message);
        }
      });
    },
    findConfig() {
      this.showloding = true;
      this.axios.get(this.api.api_findOneConfigByKeyName, {
        params: { key_name: "currency_odd" }
      })
        .then((res) => {
          this.showloding = false;
          if (res.data.code == 0) {
            let currency_odd = res.data.data.key_value.split("#");
            this.odds = currency_odd.map(item => {
              return { during: item.split("-")[0], odd: item.split("-")[1] }
            });
            this.util.refreshUserInfo((res) => this.userInfo = res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createKline() {
      let symbol = "BINANCE:" + this.$route.query.name_2 + "USDT";
      //let symbol = "CRYPTO:"+this.$route.query.name+"USD";
      //eslint-disable-next-line no-undef
      new TradingView.widget(
        {
          "width": screen.width - 5,
          "height": 395,
          "symbol": symbol,
          "interval": "D",
          "timezone": "exchange", // Asia/Shanghai
          "theme": "light", // dark or light
          "style": "3",
          "locale": "en_US", //zh_CN
          "toolbar_bg": "#f1f3f6",
          "enable_publishing": false,
          "allow_symbol_change": false,
          "hide_side_toolbar": true,
          "studies": ["STD;SMA", "STD;MACD"],
          "container_id": "tradingview_27984"
        }
      );
    }
  },
  mounted() {
    this.name = this.$route.query.name;
    this.name_2 = this.$route.query.name_2;
    if (!this.util.isLogin()) this.util.topage('login');
    this.getOrder();
    this.getOneGains();
    this.createKline();
  },
  destroyed() {
    window.clearTimeout(this.timer)
  },
};
</script>
<style lang="scss" scoped>
.home-content {
  font-size: 0.32rem;
  background: rgb(235, 235, 235);
  color: black;
  width: 100%;
  height: 100%;

  .first-pard {
    height: 40px;
    display: grid;
    grid-template-columns: 30% 1fr 30%;
    align-items: center;
    text-align: center;
    font-size: 0.36rem;
    font-weight: bold;
    color: black;

    :nth-child(1) {
      cursor: pointer;

      img {
        display: block;
        width: 18px;
        margin-left: 5%;
        transform: rotate(180deg);
      }
    }
  }

  .second-pard {
    background: white;

    // margin-bottom: 3px;
    .head-one {
      font-weight: bolder;
      font-size: 22px;
      // color:black;
      // height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      :nth-child(1) {
        padding-left: 2%;
        text-align: left;
      }
    }

    .head-two {
      height: 98px;
      font-size: 0.32rem;
      display: flex;
      justify-content: space-between;

      .price {
        padding-left: 2%;
        text-align: left;
        width: 35%;
        font-weight: bold;
        font-size: 0.32rem;
        padding: 3px 8px;

        :nth-child(2) {
          font-size: 21px;
        }
      }

      .time-name {
        text-align: left;
        font-weight: bold;
      }

      .time-num {
        padding-right: 2%;
        text-align: right;
      }
    }
  }

  .third-pard {
    height: 365px;
    width: 100%;
    background: white;
    display: flex;
    justify-content: center;
  }

  .four-pard-head {
    width: 99%;
    margin: auto;
    background: white;

    ul {
      display: grid;
      font-size: 0.32rem;
      grid-template-columns: 25% 22% 20% 1fr;
      font-weight: bold;
      background-color: bisque;
      padding: 4px 4px;
    }
  }

  .four-pard-text {
    width: 99%;
    margin: auto;
    background: white;
    padding-bottom: 180px;
    height: 350px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    ul {
      display: grid;
      font-size: 0.32rem;
      grid-template-columns: 22% 25% 18% 1fr;
      padding: 3px 4px;
    }
  }

  .five-pard {
    width: 100%;
    height: 1rem;
    background: rgb(238, 233, 233);
    //position: fixed;
    //left: 0;
    //bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    //border-top: 0.01rem solid rgb(180, 175, 175);
    margin-top: 0.25rem;

    button {
      color: white;
      font-size: 0.32rem;
      border-radius: 4px;
      width: 47%;
      height: 37px;
      margin: 0 0.12rem;
    }

    .btn-up {
      background: #628808;
    }

    .btn-down {
      background: #f6543e;
    }
  }

  .six-pard {
    width: 98%;
    background: white;
    margin: auto;
    padding: 5px 8px;
    border-radius: 10px/10px;

    .xzje {
      font-size: 0.32rem;
      margin-top: 8px;
      padding-left: 5px;
      color: black;
      font-weight: bold;
    }

    ul {
      width: 100%;
      cursor: pointer;
      display: grid;
      grid-template-columns: 20% 20% 20% 20% 20%;
      justify-items: center;

      button {
        border-radius: 5px/5px;
        margin: 5px auto;
        padding: 4px 0;
        width: 1.78rem;
        color: black;
        border: 1px solid rgb(232, 234, 237);
      }

      .on,
      button:hover {
        background: #628808;
        color: white;
      }
    }

    .order-head {
      margin: 10px 1.5px;
      font-weight: bold;
      background-color: bisque;
      padding: 5px 0;
      font-size: 0.32rem;
    }

    .order-text {
      padding-bottom: 5px;
      font-size: 0.34rem;
    }

    .btn-during {
      button {
        display: grid;

        :last-child {
          color: #f6543e;
        }
      }

      .on span,
      button span:hover {
        color: white;
      }
    }

    .btn-money {
      display: grid;
      grid-template-columns: 16.66% 16.66% 16.66% 16.66% 16.66% 1fr;
      justify-items: center;

      button {
        width: 1.4rem;
      }
    }

    .money {
      width: 100%;
      height: 40px;
      border-radius: 5px/5px;
      color: black;
      border: 1px solid rgb(178, 201, 235);
      margin: 0px 0px;
      padding: 0 10px;
    }

    .btn-submit {
      margin: 5px auto;
      width: 100%;
      border-radius: 4px;
      font-size: 0.34rem;
      height: 40px;
      background: #628808;
      color: white;
    }

    .btn-submit:hover {
      background: #628808;
    }

    .errorInfo {
      display: flex;
      justify-content: center;
      color: #f6543e;
    }
  }
}
</style>